import { SatelliteJob } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateSatelliteJobArgs,
    getDefaultSatelliteJobCreateArgs,
    UpdateSatelliteJobArgs,
} from "@nova/serializer/src/client/validators/jobs/satellite"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectUserEmail, selectUserLicense } from "user/profile/selectors"
import { addEntitySocket } from "features/entity-caching/project/slice"

const {
    create: createSatelliteJob,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    SatelliteJob, // entity type
    CreateSatelliteJobArgs, // create args to send to server
    [], // create args required by action
    UpdateSatelliteJobArgs, // update args
    { flightId: string; triggerDispatch?: boolean; temporalBias?: string }, // required input context
    {
        flightId: string
        projectId: string
        orgId: string
        userEmail: string
        queue: "premium"
        portfolioName: string
        licenseId: string
        triggerDispatch?: boolean
        temporalBias?: string
    } // server context
>("SatelliteJob")

export const addSatelliteJobsToBuilder = (builder: Builder) =>
    builder.addCase(createAction, (store, { payload: { context } }, socket) => {
        const state = store.getState()
        const { flightId } = context
        const projectId = selectActivatedFireId(state)!
        const org = selectActiveWorkspace()(state)!
        const userEmail = selectUserEmail(state)!
        const license = selectUserLicense(state)

        createSatelliteJob(socket, getDefaultSatelliteJobCreateArgs(), {
            flightId,
            projectId,
            orgId: org.id,
            userEmail,
            portfolioName: org.name,
            licenseId: license?.licenseId ?? "",
            queue: "premium",
            triggerDispatch: context.triggerDispatch,
            temporalBias: context.temporalBias,
        })
        store.dispatch(
            addEntitySocket({
                data: { ...getDefaultSatelliteJobCreateArgs(), resourceName: "mock" },
                path: ["satelliteFlights", { id: flightId }, "job"],
            })
        )
    })
export {
    createAction as createSatelliteJob,
    updateAction as updateSatelliteJob,
    deleteAction as deleteSatelliteJob,
}
